export type AccessEum = "list" | "read" | "create" | "update" | "delete";
export type RouteNameKey =
  | "api_auth_user_role_list"
  | "api_auth_user_role_read"
  | "api_auth_user_role_create"
  | "api_auth_user_role_update"
  | "api_auth_user_role_delete"
  | "api_auth_user_list"
  | "api_auth_user_read"
  | "api_auth_user_create"
  | "api_auth_user_update"
  | "api_auth_user_delete"
  | "api_material_material_type_list"
  | "api_material_material_type_read"
  | "api_material_material_type_create"
  | "api_material_material_type_update"
  | "api_material_material_type_delete"
  | "api_storage_open_storage_list"
  | "api_storage_open_storage_read"
  | "api_storage_open_storage_create"
  | "api_storage_open_storage_update"
  | "api_storage_open_storage_delete"
  | "api_storage_store_storage_list"
  | "api_storage_store_storage_read"
  | "api_storage_store_storage_create"
  | "api_storage_store_storage_update"
  | "api_storage_store_storage_delete"
  | "api_storage_container_type_list"
  | "api_storage_container_type_read"
  | "api_storage_container_type_create"
  | "api_storage_container_type_update"
  | "api_storage_container_type_delete"
  | "api_storage_cement_packaging_list"
  | "api_storage_cement_packaging_read"
  | "api_storage_cement_packaging_create"
  | "api_storage_cement_packaging_update"
  | "api_storage_cement_packaging_delete"
  | "api_storage_storage_list"
  // | "api_material_material_list"
  | "api_customer_customer_list"
  | "api_staff_staff_list"
  // | "api_staff_staff_read"
  // | "api_staff_staff_create"
  // | "api_staff_staff_update"
  // | "api_staff_staff_delete"
  | "menu_operation_operation_choice_sub_menu"
  //| "api_material_material_type_count_list"
  | "api_material_material_type_count_list_select"
  | "menu_work_calendar_sub_menu"
  | "api_operation_damage_type_list"
  | "api_operation_damage_zone_list"
  | "menu_kpi"
  | "api_operation_load_damage_list"
  | "api_staff_absence_list"
  | "api_transport_order_list"
  | "api_operation_cadence_list"
  | "api_booking_list"
  | "api_booking_customer_removal_control_list"
  | "api_booking_exit_note_list"
  | "api_booking_restitution_control_list"
  | "api_storage_open_storage_list_0"
  | "api_storage_storage_movement_history_list_open_storage"
  | "api_storage_store_storage_list_0"
  | "api_storage_storage_movement_history_list_store_storage"
  | "api_booking_goods_removal_control_list"
  | "api_booking_exit_note_list_0"
  | "api_document_document_list";

export const MenuKeys: Record<
  RouteNameKey,
  {
    routeName: string;
    action: AccessEum;
    children: Array<{
      routeName: string;
      action: AccessEum;
    }>;
  }
> = {
  // Documents
  api_document_document_list: {
    routeName: "/app/files",
    action: "list",
    children: [],
  },
  // Parc container
  api_booking_list: {
    routeName: "/app/container-yard/booking",
    action: "list",
    children: [],
  },
  api_booking_customer_removal_control_list: {
    routeName: "/app/container-yard/gate-out",
    action: "list",
    children: [],
  },
  api_booking_exit_note_list: {
    routeName: "/app/container-yard/release-orders",
    action: "list",
    children: [],
  },
  api_booking_restitution_control_list: {
    routeName: "/app/container-yard/gate-in",
    action: "list",
    children: [],
  },
  api_storage_open_storage_list_0: {
    routeName: "/app/container-yard/open-storage",
    action: "list",
    children: [],
  },
  api_storage_storage_movement_history_list_open_storage: {
    routeName: "/app/container-yard/open-storage/history",
    action: "list",
    children: [],
  },
  // Gestion personnel
  api_staff_staff_list: {
    routeName: "/app/rh/employees",
    action: "list",
    children: [],
  },
  // api_staff_staff_read: {
  //   routeName: "/app/employees",
  //   action: "read",
  //   children: [],
  // },
  // api_staff_staff_create: {
  //   routeName: "/app/employees",
  //   action: "create",
  //   children: [],
  // },
  // api_staff_staff_update: {
  //   routeName: "/app/employees",
  //   action: "update",
  //   children: [],
  // },
  // api_staff_staff_delete: {
  //   routeName: "/app/employees",
  //   action: "delete",
  //   children: [],
  // },
  // User role menu access
  api_auth_user_role_list: {
    routeName: "/app/settings/roles",
    action: "list",
    children: [],
  },
  api_auth_user_role_read: {
    routeName: "/app/settings/roles",
    action: "read",
    children: [],
  },
  api_auth_user_role_create: {
    routeName: "/app/settings/roles",
    action: "create",
    children: [],
  },
  api_auth_user_role_update: {
    routeName: "/app/settings/roles",
    action: "update",
    children: [],
  },
  api_auth_user_role_delete: {
    routeName: "/app/settings/roles",
    action: "delete",
    children: [],
  },
  // User menu access
  api_auth_user_list: {
    routeName: "/app/settings/users",
    action: "list",
    children: [],
  },
  api_auth_user_read: {
    routeName: "/app/settings/users",
    action: "read",
    children: [],
  },
  api_auth_user_create: {
    routeName: "/app/settings/users",
    action: "create",
    children: [],
  },
  api_auth_user_update: {
    routeName: "/app/settings/users",
    action: "update",
    children: [],
  },
  api_auth_user_delete: {
    routeName: "/app/settings/users",
    action: "delete",
    children: [],
  },
  // Material type access
  api_material_material_type_list: {
    routeName: "/app/settings/material-types",
    action: "list",
    children: [],
  },
  api_material_material_type_read: {
    routeName: "/app/settings/material-types",
    action: "read",
    children: [],
  },
  api_material_material_type_create: {
    routeName: "/app/settings/material-types",
    action: "create",
    children: [],
  },
  api_material_material_type_update: {
    routeName: "/app/settings/material-types",
    action: "update",
    children: [],
  },
  api_material_material_type_delete: {
    routeName: "/app/settings/material-types",
    action: "delete",
    children: [],
  },
  // Open storage access
  api_storage_open_storage_list: {
    routeName: "/app/settings/open-storage",
    action: "list",
    children: [],
  },
  api_storage_open_storage_read: {
    routeName: "/app/settings/open-storage",
    action: "read",
    children: [],
  },
  api_storage_open_storage_create: {
    routeName: "/app/settings/open-storage",
    action: "create",
    children: [],
  },
  api_storage_open_storage_update: {
    routeName: "/app/settings/open-storage",
    action: "update",
    children: [],
  },
  api_storage_open_storage_delete: {
    routeName: "/app/settings/open-storage",
    action: "delete",
    children: [],
  },
  // Store storage access
  api_storage_store_storage_list: {
    routeName: "/app/settings/store-storage",
    action: "list",
    children: [],
  },
  api_storage_store_storage_read: {
    routeName: "/app/settings/store-storage",
    action: "read",
    children: [],
  },
  api_storage_store_storage_create: {
    routeName: "/app/settings/store-storage",
    action: "create",
    children: [],
  },
  api_storage_store_storage_update: {
    routeName: "/app/settings/store-storage",
    action: "update",
    children: [],
  },
  api_storage_store_storage_delete: {
    routeName: "/app/settings/store-storage",
    action: "delete",
    children: [],
  },
  // Container type access
  api_storage_container_type_list: {
    routeName: "/app/settings/container-types",
    action: "list",
    children: [],
  },
  api_storage_container_type_read: {
    routeName: "/app/settings/container-types",
    action: "read",
    children: [],
  },
  api_storage_container_type_create: {
    routeName: "/app/settings/container-types",
    action: "create",
    children: [],
  },
  api_storage_container_type_update: {
    routeName: "/app/settings/container-types",
    action: "update",
    children: [],
  },
  api_storage_container_type_delete: {
    routeName: "/app/settings/container-types",
    action: "delete",
    children: [],
  },
  // Cement packaging access
  api_storage_cement_packaging_list: {
    routeName: "/app/settings/cement-packaging",
    action: "list",
    children: [],
  },
  api_storage_cement_packaging_read: {
    routeName: "/app/settings/cement-packaging",
    action: "read",
    children: [],
  },
  api_storage_cement_packaging_create: {
    routeName: "/app/settings/cement-packaging",
    action: "create",
    children: [],
  },
  api_storage_cement_packaging_update: {
    routeName: "/app/settings/cement-packaging",
    action: "update",
    children: [],
  },
  api_storage_cement_packaging_delete: {
    routeName: "/app/settings/cement-packaging",
    action: "delete",
    children: [],
  },
  // Entroposage
  api_storage_storage_list: {
    routeName: "/app/storage",
    action: "list",
    children: [],
  },
  api_storage_store_storage_list_0: {
    routeName: "/app/storage",
    action: "list",
    children: [],
  },
  api_storage_storage_movement_history_list_store_storage: {
    routeName: "/app/storage/history",
    action: "list",
    children: [],
  },
  api_booking_goods_removal_control_list: {
    routeName: "/app/storage/gate-passes",
    action: "list",
    children: [],
  },
  api_booking_exit_note_list_0: {
    routeName: "/app/storage/release-orders",
    action: "list",
    children: [],
  },
  /* api_material_material_type_count_list: {
    routeName: "/app/material",
    action: "list",
    children: [],
  }, */
  api_material_material_type_count_list_select: {
    routeName: "/app/material",
    action: "list",
    children: [],
  },

  //Material
  // api_material_material_list: { //Old version
  //   routeName: "/app/material",
  //   action: "list",
  //   children: [],
  // },
  api_customer_customer_list: {
    routeName: "/app/customer",
    action: "list",
    children: [],
  },

  //Operations
  menu_operation_operation_choice_sub_menu: {
    routeName: "/app/operations",
    action: "list",
    children: [],
  },

  //Settings
  menu_work_calendar_sub_menu: {
    routeName: "/app/settings/work-calendar",
    action: "list",
    children: [],
  },
  // Damage type and zone
  api_operation_damage_type_list: {
    routeName: "/app/settings/damaged-type",
    action: "list",
    children: [],
  },
  api_operation_damage_zone_list: {
    routeName: "/app/settings/damaged-zone",
    action: "list",
    children: [],
  },
  api_operation_cadence_list: {
    routeName: "/app/settings/schedules",
    action: "list",
    children: [],
  },
  //DASHBOARD
  menu_kpi: {
    routeName: "/app/dashboard",
    action: "list",
    children: [],
  },

  api_staff_absence_list: {
    routeName: "/app/rh/missing",
    action: "list",
    children: [],
  },
  api_operation_load_damage_list: {
    routeName: "/app/settings/damaged",
    action: "list",
    children: [],
  },
  api_transport_order_list: {
    routeName: "/app/transport-order",
    action: "list",
    children: [],
  },
};
